import darkCarbon from "./darkCarbon";
import darkCobalt from "./darkCobalt";
import darkSolarized from "./darkSolarized";
import darkSpaceGray from "./darkSpaceGray";
import dracula from "./dracula";
import monokai from "./monokai";
const gridThemes = {
    dracula,
    monokai,
    darkCarbon,
    darkCobalt,
    darkSolarized,
    darkSpaceGray,
};
export default gridThemes;
